module.exports = __webpack_public_path__ + "static/media/painel-revenda-pessoas.7f5b1aec.png";